import standardAPI from '@/api/standard_items';

const responseUrl = '/world-tours/cities';

const state = {
  cities: [],
  cities_MetaData: {},
  cities_status: '',
  cities_page: 1,
  cities_perPage: 10,
};

const getters = {
  get_cities: (state) => {
    return state.cities;
  },
  get_cities_status: (state) => {
    return state.cities_status;
  },
};

const actions = {
  set_current_page ({ commit }, page) {
    commit('SET_CURRENT_PAGE', page);
  },
  set_perPage ({ commit }, max) {
    commit('SET_PER_PAGE', max);
  },
  fetch_cities ({ commit }, getOptions) {
    commit('DATA_CITIES_REQUEST');
    const preparedOptions = {
      getParams: getOptions.pageOptions,
      url: responseUrl,
      token: getOptions.token,
    };
    return new Promise((resolve, reject) => {
      standardAPI.get_items((response) => {
        try {
          if (response && response.status !== 404) {
            commit('DATA_CITIES_UPDATE_SUCCESS', response);
            commit('DATA_CITIES_READY');
            resolve(response);
          } else if (response.status === 404) {
            commit('DATA_CITIES_READY');
            reject(response);
          } else {
            commit('DATA_CITIES_ERROR');
            reject(response);
          }
        } catch (error) {
          console.log(error);
        }
      }, preparedOptions);
    });
  },
  fetch_cities_silent ({ commit }, getOptions) {
    const preparedOptions = {
      getParams: getOptions.pageOptions,
      url: responseUrl,
    };
    return new Promise((resolve, reject) => {
      standardAPI.get_items((response) => {
        try {
          if (response && response.status !== 404) {
            resolve(response);
          } else if (response.status === 404) {
            reject(response);
          } else {
            reject(response);
          }
        } catch (error) {
          console.log(error);
        }
      }, preparedOptions);
    });
  },
  add_city ({ commit, dispatch }, itemData) {
    commit('DATA_CITIES_REQUEST');
    const preparedData = {
      itemData,
      url: responseUrl,
    };
    return new Promise((resolve, reject) => {
      standardAPI.add_item(preparedData, (response) => {
        if (response.status === 'created') {
          commit('DATA_CITIES_REQUEST');
          resolve(response);
        } else {
          commit('DATA_CITIES_READY');
          reject(response);
        }
      });
    });
  },
  edit_city ({ commit, dispatch }, itemData) {
    commit('DATA_CITIES_REQUEST');
    const preparedData = {
      itemData,
      url: responseUrl + '/',
    };
    return new Promise((resolve, reject) => {
      standardAPI.edit_item(preparedData, (response) => {
        if (response.status === 'updated') {
          commit('DATA_CITIES_REQUEST');
          resolve(response);
        } else {
          commit('DATA_CITIES_READY');
          reject(response);
        }
      });
    });
  },
  remove_cities ({ commit, dispatch }, itemData) {
    commit('DATA_CITIES_REQUEST');
    const preparedData = {
      itemData,
      url: responseUrl,
    };
    return new Promise((resolve, reject) => {
      standardAPI.remove_items(preparedData, (response) => {
        if (response.status === 'deleted') {
          commit('DATA_CITIES_REQUEST');
          resolve();
        } else {
          commit('DATA_CITIES_READY');
          reject(response);
        }
      });
    });
  },
  reorder_city ({ commit, dispatch }, orderData) {
    const preparedData = {
      orderData,
      url: responseUrl + '/reorder',
    };
    return new Promise((resolve, reject) => {
      standardAPI.reorder_item(preparedData, (response) => {
        if (response.status === 'reorder') {
          resolve(response);
        } else {
          reject(response);
        }
      });
    });
  },
  set_city_order ({ commit, dispatch }, itemData) {
    const preparedData = {
      itemData,
      url: responseUrl + '/set-reorder-index/' + itemData.id,
    };
    return new Promise((resolve, reject) => {
      standardAPI.reorder_item_number(preparedData, (response) => {
        if (response.status === 'reorder') {
          resolve(response);
        } else {
          reject(response);
        }
      });
    });
  },
};

const mutations = {
  SET_CURRENT_PAGE: (state, pageNumber) => {
    state.cities_page = pageNumber;
  },
  SET_PER_PAGE: (state, max) => {
    state.cities_perPage = max;
  },
  DATA_CITIES_READY: (state) => {
    state.cities_status = 'ready';
  },
  DATA_CITIES_REQUEST: (state) => {
    state.cities_status = 'loading';
  },
  DATA_CITIES_UPDATE_SUCCESS: (state, response) => {
    if (response && response.meta) {
      state.cities_MetaData.meta = response.meta;
      state.cities_MetaData.links = response.links;
    }
    if (response && response.data) {
      state.cities = response.data || [];
      console.log('state.cities',state.cities)
    }
    state.cities_status = 'success';
  },
  DATA_CITIES_ERROR: (state) => {
    state.cities_status = 'error';
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
